// Generated file : do not modify
import User from '@/extend/classes/User';
import Etablissement from '@/extend/classes/Etablissement';
import Dialog from '@/extend/classes/Dialog';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import ListData from '@/extend/classes/ListData';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// 
export class SiretInscriptionAnswser {
  // Inscription complète
  public success: boolean;
  // Inscription complète
  public verified: boolean;
  // token provisoire pour acceder aux listes
  public token: string;
  // Données de l'établissemnt
  public etablissement: Etablissement;
  // Information
  public dialog: Dialog;
  // Verification mail
  public verifyMail: boolean;
  // Verification numero
  public verifyNumero: boolean;
  // mail valide
  public validMail: boolean;
  // numero valid
  public validNumero: boolean;

  constructor() {
    this.success = false;
    this.verified = false;
    this.token = '';
    this.etablissement = new Etablissement();
    this.dialog = new Dialog();
    this.verifyMail = false;
    this.verifyNumero = false;
    this.validMail = false;
    this.validNumero = false;
  }
}

export default class SiretInscription  {
  // Information du contact
  public user: User;
  // Information de l'établissement
  public etablissement: Etablissement;
  // token provisoire pour acceder aux listes
  public token: string;
  // Code de vérification
  public code: string;
  // Password
  public password: string;
  // Client mobile
  public isMobile: boolean;
  // Verification mail
  public verifyMail: boolean;
  // Verification numero
  public verifyNumero: boolean;
  // mail valide
  public validMail: boolean;
  // numero valid
  public validNumero: boolean;

  constructor() {
    this.user = new User();
    this.etablissement = new Etablissement();
    this.token = '';
    this.code = '';
    this.password = '';
    this.isMobile = false;
    this.verifyMail = false;
    this.verifyNumero = false;
    this.validMail = false;
    this.validNumero = false;
  }

  public static fromJson (obj: SiretInscription): SiretInscription {
    const newSiretInscription: SiretInscription = new SiretInscription();
    newSiretInscription.user = JSON.parse(JSON.stringify(obj.user));
    newSiretInscription.etablissement = JSON.parse(JSON.stringify(obj.etablissement));
    newSiretInscription.token = obj.token;
    newSiretInscription.code = obj.code;
    newSiretInscription.password = obj.password;
    newSiretInscription.isMobile = obj.isMobile;
    newSiretInscription.verifyMail = obj.verifyMail;
    newSiretInscription.verifyNumero = obj.verifyNumero;
    newSiretInscription.validMail = obj.validMail;
    newSiretInscription.validNumero = obj.validNumero;
    return newSiretInscription;
  }

  public toJsonSiretInscription (): string {
    const json = {
      user: this.user,
      etablissement: this.etablissement,
      token: this.token,
      code: this.code,
      password: this.password,
      isMobile: this.isMobile,
      verifyMail: this.verifyMail,
      verifyNumero: this.verifyNumero,
      validMail: this.validMail,
      validNumero: this.validNumero,
    }
    return JSON.stringify(json);
  }

  public fromSiretInscription (obj: SiretInscription): void {
    this.user = obj.user;
    this.etablissement = obj.etablissement;
    this.token = obj.token;
    this.code = obj.code;
    this.password = obj.password;
    this.isMobile = obj.isMobile;
    this.verifyMail = obj.verifyMail;
    this.verifyNumero = obj.verifyNumero;
    this.validMail = obj.validMail;
    this.validNumero = obj.validNumero;
  }

  public compareSiretInscription (value: SiretInscription): boolean {
    return (this.toJsonSiretInscription() == value.toJsonSiretInscription());
  }

  public cloneSiretInscription (): SiretInscription {
    return SiretInscription.fromJson(this);
  }

  public static verifySiret (inscription: SiretInscription): Promise<SiretInscriptionAnswser> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/siretinscriptions/verifySiret', inscription, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static verifyEmail (inscription: SiretInscription): Promise<SiretInscriptionAnswser> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/siretinscriptions/verifyEmail', inscription, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static validateEmail (inscription: SiretInscription): Promise<SiretInscriptionAnswser> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/siretinscriptions/validateEmail', inscription, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static verifyNumero (inscription: SiretInscription): Promise<SiretInscriptionAnswser> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/siretinscriptions/verifyNumero', inscription, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static validateNumero (inscription: SiretInscription): Promise<SiretInscriptionAnswser> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/siretinscriptions/validateNumero', inscription, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static subscribeSiret (inscription: SiretInscription): Promise<SiretInscriptionAnswser> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/siretinscriptions/subscribeSiret', inscription, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static resetCodeMail (inscription: SiretInscription): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/siretinscriptions/resetCodeMail', inscription, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static resetCodeNumero (inscription: SiretInscription): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/siretinscriptions/resetCodeNumero', inscription, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(siretInscriptions: SiretInscription[]) {
  }
}
